import { render, staticRenderFns } from "./overpurchase.vue?vue&type=template&id=1851cbed&"
import script from "./overpurchase.vue?vue&type=script&lang=js&"
export * from "./overpurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports